import { render } from "./WaterCalculator.vue?vue&type=template&id=2184073d"
import script from "./WaterCalculator.vue?vue&type=script&lang=js"
export * from "./WaterCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__